// pages/SpacePage.jsx — Anamoria SPA
// v2.56 — NEW-171 Phase 3 (Leader Home, increment A): restore a persistent, leader-only
//   "Leader home" entry at the TOP of the sidebar (role-gated on pilotRole === 'leader',
//   independent of any group space) that routes to /leader. Un-does the v2.55 sidebar-link
//   removal, done right for multi-cohort: ONE entry; the cohort switcher carries plurality.
//   Fixes the net-new-leader dead-end (no door to the dashboard before a group space exists).
//   Non-leaders byte-identical. (Nov 2, 2026)
// v2.55 — NEW-171 Phase 3 (SPA PR-1, LIVE not dark): group-space feeds default to the Shared tab
//   (initialTab layered over notificationTab so notification nav still wins); removed the redundant
//   leader-only "Group Dashboard" sidebar link — the header button remains the sole entry. (Nov 1, 2026)
// v2.54 — 2026-10-30: NEW-163 Increment B — passes groupNotes + leaderName to MemoryFeed v2.47 so a member's
//   response (row with groupNoteId) renders the response card and resolves its pill on the Shared / To review
//   tabs. The leader's own GroupNoteBanner is unchanged (no Respond for the leader — plan v0.5 decision 5).
// v2.53 — 2026-10-29: NEW-162 Increment A — GroupNoteBanner in a GROUP space, under the feed tabs as the
//   first thing in the feed (MemoryFeed v2.46 topSlot; mockup v0.9 placement C, paper card / terracotta). Data = space.groupNotes from GET /spaces/{id} (anamoria-spaces
//   v1.20). Leader (pilotRole === 'leader') can "Share a new note" → POST /leader/note (anamoria-leader v1.11);
//   the response becomes the current note, the old one moves to Earlier notes, and the space cache is refreshed.
//   Gated space.isGroupSpace && group_spaces_enabled; non-group spaces byte-identical. One-way (no Reply yet).
// v2.52 — 2026-10-18: add a leader-only "Group Dashboard" button to the group-space header
//   (.headerRight), gated space.isGroupSpace && pilotRole === 'leader', routes to /leader (reuses
//   DashboardIcon). Surfaces the existing sidebar-only entry; sidebar link unchanged. Frontend-only.
// v2.51 — UI cleanup (2026-10-14): hero subtitle reworded + made group-aware. Personal:
//   "Somewhere to remember and keep them close"; group (space.isGroupSpace): "...keep our
//   loved ones close" (echoes the Vision's "keep close"). Copy-only, flag-scoped to the
//   feed_redesign_v2 hero. Pairs with MemoryFeed v2.44.
// v2.50 — T-5 (2026-09-13): persona-aware onboarding tour. On feed_redesign_v2 the
//   Member/Owner steps are anchored to today's surface (MomentFooter add/invite + feed
//   tabs), the loved-one name is interpolated, momentsEnabled filter dropped for that set.
//   Legacy (flag-off) steps byte-identical. Copy v0.4. (T-5 Increment 1)
// v2.49 — B4 hero: the feed hero now lives INSIDE the scroll container and scrolls away naturally
//   (native scroll = smooth); the sticky tabs pin as it leaves. Removes the max-height collapse animation
//   (uncomposited -> jank). Handler only fades the sticky Add now, no hero collapse. (Sept 4, 2026)
// v2.48 — Phase 2: group-space header marker (subtitle shows a people icon + "Group space" when
//   space.isGroupSpace) + pass pendingReviewCount to MemoryFeed for the To-review tab badge. (Sept 3, 2026)
// v2.47 — pass spaceIsGroup (space.isGroupSpace, backend is_group_space) to MemoryFeed so the
//   "To review" tab shows only for GROUP spaces, per space. Frontend-only. (Sept 1, 2026)
// v2.46 — subtler + cross-browser collapse: max-height (measured into --hero-h) at 650ms replaces the
//   grid-template-rows animation, which did not animate in Safari (snapped -> the "blip"). See .module.css v2.23.
// v2.45 — feed hero collapse fix (member/flag feed_redesign_v2): (a) OSCILLATION —
//   only collapse when the feed stays scrollable after the hero (a flex sibling above
//   flex:1 .main) frees its height into .main; on a short feed collapsing flipped .main
//   scrollable<->not, the browser clamped scrollTop, and collapse<->expand oscillated
//   (the flashing at ~5 memories — unusable in the CTO demo). Short feeds now stay
//   expanded. Guard: remainingAfterCollapse = (scrollHeight-clientHeight)-heroHeight > 160.
//   (b) rAF-throttle the scroll handler (trace showed heavy paint/commit churn).
//   (c) smooth collapse via grid-template-rows 1fr->0fr on .feedHeaderV2 (see .module.css
//   v2.21) — hero content wrapped in .heroInner. No behaviour/data change.
// v2.44 — item 4 portrait fix: on narrow screens (<=640px) the header space-name (.headerInfo, headerInfoRef)
//   fades when the hero collapses, so the centered sticky Add owns the header center instead of overlapping the
//   name (avatar stays for identity); desktop keeps the name.
// v2.43 — item 4: sticky "Add a memory" (.feedStickyAdd, stickyAddRef) fades into the header when the hero
//   collapses (shares the [data-collapsed] toggle; brand sage var(--moment-action-brand), matches the hero btn),
//   so the primary action stays present once the big hero Add scrolls away. Scoped to the redesign feed.
// v2.42 — item 4 collapse-on-scroll: the feedHeaderV2 hero collapses as the feed scrolls. heroRef is
//   toggled inside the EXISTING handleScroll alongside promptSectionRef (own guard, since the flag-on feed
//   renders feedHeaderV2 not promptSection). Hero is OUTSIDE .main, so collapsing it does not affect
//   main.scrollTop — no oscillation (same guarantee as the v2.18 prompt). Full-collapse; reuses the shipped
//   50px-down / scroll-up-or-near-top cadence. CSS: .feedHeaderV2[data-collapsed]; reduced-motion honored.
// v2.41 — PR2 (Option C): retire the duplicate .settingsNav* launcher. The header
//   gear and the left-sidebar profile Settings entry now open the same overlay as the
//   footer gear (navigate to /settings with state.backgroundLocation). Removed the
//   settingsNav overlay JSX/state/handlers and its 9 copied icon components.
// v2.40 — settings overlay-on-feed: removed the settings_overlay flag (pre-launch,
//   no users). The footer Settings/Support gears always open /settings as an overlay
//   over the feed (MomentFooter carries backgroundLocation itself).
// v2.38 — feed_redesign_v2: drop redundant client-side moments gate (July 28, 2026)
//   anamoria-spaces v1.9 now resolves feed_redesign_v2 = (moments && redesign)
//   server-side, so the SPA reads one resolved boolean. Behaviour unchanged.
// v2.37 — feed_redesign_v2: one continuous surface (July 27, 2026)
//   Adds .pageV2 when feedRedesignEnabled → header bar + ground share the warm
//   ground (#FAF7F1), replacing pageV's white header + #FAF7EF ground for this
//   flag ("too white" header / "too brown" ground per Sophie). See
//   SpacePage.module.css v2.11. pageV (moments) untouched.
// v2.36 — feed_redesign_v2: static header replaces the prompt (July 27, 2026)
//   New flag feed_redesign_v2 (fail-closed), layered on moments_enabled. When
//   on: the prompt section is replaced by a static header ("Memories" /
//   "A space for {name}." / subhead / "Add a memory" → /add). Flag off ⇒ the
//   legacy prompt section renders byte-identical. Header styles + Fraunces/Inter
//   @font-face in SpacePage.module.css v2.10. Copy = hearth design-system §1,
//   brand-voice-passed 2026-07-27. AD phase 1 of 4 (tabs/cards/ground follow).
// v2.35 — B2a: gate the Pending Approval tab on leader role (July 27, 2026)
//   The approval tab is leader-only (handleReviewMemory is owner-scoped to the
//   group-space owner). AND the group_spaces_enabled flag with
//   appState?.pilotRole === 'leader' (mirrors the Group Dashboard sidebar gating)
//   so non-leader pilot members never see an empty approval tab.
// v2.34 — B2a: pass groupSpacesEnabled to MemoryFeed (July 27, 2026)
//   Reads appState.flags?.group_spaces_enabled (=== true, fail-closed) and
//   passes it to <MemoryFeed> to gate the Pending Approval tab. Flag falsy ⇒
//   prop inert, byte-identical. (moment-group-spaces-B2a-pending-approval-tab-plan-v0.3.md)
// v2.33 — 4.3: after-remove confirmation toast on the feed (July 24, 2026)
//   A return from MomentDetailPage's whole-memory remove carries
//   location.state.removedToast → show DS-13 (copy v0.12), then strip it from
//   history. Plan v0.12 (D-4.17). One-tap undo = committed fast-follow.
// v2.32 — 3.2: highlightMode passthrough for scroll-return (July 21, 2026)
//   A return from MomentDetailPage carries { memoryId, scrollOnly } (F-D2(a),
//   momentdetail-3-2-DRAFT-for-review-v0.3.md E-7): the feed scrolls to the
//   card WITHOUT the gold pulse (pulse = changed content). Notification
//   navigations keep pulsing; scrollOnly joins the consumed-state cleanup.
//   Nothing else touched.
// v2.31 — 3.1-V: flagged warm ground on .page (July 20, 2026)
//   `pageV` class when momentsEnabled (momentcard-3-1V-presentation-DRAFT-
//   for-review-v0.4.md §5, D-3.19): ground #F8F3E8 (measured, v0.3 §6) on
//   page + header surfaces. Header contents untouched (header treatment =
//   later phase). Flag falsy ⇒ class absent, byte-identical.
// v2.30 — 3.1: pass momentsEnabled + spaceName to MemoryFeed (July 20, 2026)
//   Two props added to the existing <MemoryFeed> call (momentcard-3-1-DRAFT-
//   for-review-v0.4.md §5, F-2). Flag falsy ⇒ both props inert; MemoryFeed
//   v2.16 defaults preserve v2.15 behaviour byte-identically. Nothing else
//   touched.
// v2.29 — 2.1c: flag-gated footer + gear removal (July 19, 2026)
//   When appState.flags?.moments_enabled === true (Aspera canary):
//   MomentFooter v0.1 replaces BottomNav v1.4; header settings gear omitted
//   (footer = sole Settings entry per D8 — the v2.27 settings overlay is
//   intentionally unreachable for these users); tour steps targeting
//   BottomNav buttons + settings-gear filtered out (D-2.1c-4 extended —
//   INTERIM guard only; full tour redo is a logged post step [SOPHIE
//   2026-07-19]). Flag falsy ⇒ every render path byte-identical to v2.28
//   (fail-closed, D1). BottomNav.jsx untouched. Executes plan v0.4 step
//   2.1c; addmemory-2.1c-entry-footer-DRAFT-for-review-v0.2.md (note: draft
//   said v2.27→v2.28 — stale; file was already v2.28, so this is v2.29).
// v2.28 — Tour prompt no longer re-fires after completion/dismiss: sync
//   onboardingComplete into appState via updateOnboarding (July 5, 2026)
// v2.27 — Settings nav overlay: gear icon opens settings menu on top of feed (June 23, 2026)
//   - Gear icon onClick changed from navigate('/settings?from=...') to toggling
//     settingsNavOpen state. Sidebar "Settings" link does the same.
//   - New settings nav overlay: backdrop + slide-in drawer with GLOBAL (Account,
//     Security), SPACE (Space, Contributors, Reminders, Recently Deleted), and
//     QUICK ACTIONS (Need Help, App Tour, Suggestions) sections, plus Sign Out.
//   - Each nav item closes overlay and navigates to /settings?from={spaceId}&section={id}.
//   - Backdrop click or X closes overlay, user stays on feed.
//   - New inline SVG icon components for settings nav items (copied from SettingsPage).
//   - New CSS classes: settingsNav*, matching existing sidebar pattern.
//
// v2.26 — Account-link F2: "Spaces you contribute to" sidebar section (May 31, 2026)
//   - New sidebar section below SWITCH SPACE, lazy-loaded on first sidebar open
//     via GET /me/contributions (owner JWT client; not part of bootstrap).
//   - Each linked space navigates to /contributing/:spaceId/memories (F1 route).
//   - Inline unlink (DELETE /me/contributions/:spaceId/link) clears the link
//     only; renders nothing when the user has no linked contributions.
//   - No change to bootstrap, existing SWITCH SPACE rendering, or other logic.
//
// v2.25 — Fix notification navigation for same-route + highlight (May 27, 2026)
//
// Changes from v2.24:
//   - Notification tab/memoryId: replaced one-time const initialTab with
//     reactive state (notificationTab, highlightMemoryId) driven by a
//     useEffect watching location.state._navKey. When NotificationBell
//     navigates to the same space, the _navKey changes → useEffect fires
//     → tab and memoryId state update → MemoryFeed receives new props.
//   - Passes highlightMemoryId prop to MemoryFeed (new in v2.13).
//   - startTour replaceState fix: now clears only startTour from state
//     instead of nuking all state with empty object. Preserves tab and
//     memoryId if both arrive in the same navigation.
//   - Zero changes to all other SpacePage functionality.
//
// v2.24 — Hide billing UI when billingEnabled is false (May 26, 2026)
//
// Changes from v2.23:
//   - Plan link logic: returns null when billing.billingEnabled is false.
//   - Plan badge and upgrade link in profile menu: hidden when billing is off.
//   - Soft gate pre-checks unchanged — billing.limits is already null when
//     billing is off, so the checks naturally skip.
//   - Zero changes to all other SpacePage functionality.
//
// v2.23 — Tour text updates, video step, visibilitychange dismiss (May 22, 2026)
//
// Changes from v2.22:
//   - Updated tour step content text (steps 1-6, 8-9).
//   - Added step 6: video-btn ("Record or add videos").
//   - Tour is now 9 steps (was 8).
//   - Step 9 target changed from settings-gear to sidebar-toggle with
//     updated text about navigating to settings for PIN setup.
//   - NEW: visibilitychange listener dismisses tour when app is backgrounded.
//     Prevents tour overlay rendering on top of PIN lock screen.
//
// v2.22 — Onboarding tour integration (May 22, 2026)
//
// Changes from v2.21:
//   - Import OnboardingTour and TourPrompt components.
//   - NEW state: tourActive, tourPromptVisible, tourPromptDismissed.
//   - NEW: TOUR_STEPS definition (8 steps per Build Plan v1.3 §7).
//   - NEW: location.state.startTour check (Settings → "Start tour" flow).
//   - NEW: useEffect to show TourPrompt for non-onboarded users.
//   - Added data-tour attributes to 5 target elements (space header,
//     prompt area, notification bell, sidebar toggle, settings gear).
//   - Render TourPrompt above MemoryFeed in <main>.
//   - Render OnboardingTour when tourActive === true.
//   - Zero changes to existing logic, state, hooks, or rendering.
//
// v2.21 — Settings gear icon in header (May 20, 2026)
//
// Changes from v2.20:
//   - SettingsIcon: added { size = 16 } prop (default 16 for sidebar,
//     20 for header). Follows BrandIcons size prop pattern.
//   - Added settings gear button after <NotificationBell> in .headerRight.
//     Uses existing .headerBtn class (36x36 tap target). Navigates to
//     /settings?from={spaceId}. aria-label="Settings". size={20}.
//   - No CSS changes. Sidebar SettingsIcon usage unchanged (defaults to 16).
//
// v2.20 — Notification bell in header (May 17, 2026)
//
// Changes from v2.19:
//   - Import NotificationBell component.
//   - Render <NotificationBell> to the left of the + button in the header.
//   - Zero other changes.
//
// v2.19 — UI polish: pin icon + mini prompt mic fix (April 29, 2026)
//
// Changes from v2.18:
//   - PinIcon: replaced custom map-marker SVG with Bootstrap bi-pin
//     thumbtack icon. Universally recognized "pin to top" affordance.
//   - MiniPromptBar: mic icon SVG fixed — was rendering incorrectly
//     (amber dot bug). Now uses outlined mic matching full PromptCard
//     Record button (white stroke on sage background).
//
// v2.18 — F3: Collapsible prompt outside scroll container (April 24, 2026)
//
// Changes from v2.17.1:
//   - F3 fix: Moved prompt section from inside <main> (scroll container)
//     to between <header> and <main> in the .page flex column.
//     This eliminates the scroll-position feedback loop that caused
//     shimmer/oscillation when collapsing a sticky element inside
//     its own scroll container (confirmed via 6 Chrome DevTools traces).
//   - F3 fix: Collapse/expand uses a ref (promptCollapsedRef) + direct
//     DOM class toggle via data attribute. NO React state changes on
//     scroll = NO re-renders = NO layout thrashing.
//   - F3 fix: Both PromptCard and MiniPromptBar are rendered in JSX
//     at all times. Visibility toggled via CSS class on the wrapper.
//   - F3 fix: Scroll listener dependency is [loading] so it attaches
//     once mainRef.current exists after initial render.
//   - F3 fix: Header changed from position: sticky to position: relative
//     + flex-shrink: 0 (sits above scroll container in flex column).
//   - F3 fix: Prompt section uses position: relative + flex-shrink: 0
//     (sits between header and scroll container, not inside it).
//
// v2.17.1 — Fix photo URL resolution (April 24, 2026)
// v2.17 — Space Photo + Pin-to-Top + Collapsible Prompt (April 24, 2026)
// Previous changes (v2.16): Tier A Frontend Optimizations.
// Route: /spaces/:spaceId (protected — JWT required)

import { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient } from '../api/client';
import { useAppContext } from '../App';
import { useBillingStatus, getPlanLabel } from '../hooks/useBillingStatus';
import { getCached, setCache, invalidateCache, SPACE_DETAIL_CACHE_TTL, PROMPT_CACHE_TTL } from '../utils/apiCache';
import PromptCard from '../components/PromptCard';
import BottomNav from '../components/BottomNav';
import MomentFooter from '../components/MomentFooter';   // v2.29: 2.1c flag-gated footer
import MemoryFeed from '../components/MemoryFeed';
import GroupNoteBanner from '../components/GroupNoteBanner';   // v2.53: NEW-162 leader note banner
import Toast from '../components/Toast';
import CreateSpaceModal from '../components/CreateSpaceModal';
import NotificationBell from '../components/NotificationBell';
import SoftGateModal from '../components/billing/SoftGateModal';
import OnboardingTour from '../components/OnboardingTour';
import TourPrompt from '../components/TourPrompt';
import styles from './SpacePage.module.css';

/* ─── Inline SVG icons ─── */

function HamburgerIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function ChevronUpIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 15l-6-6-6 6" />
    </svg>
  );
}

function SettingsIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

function DashboardIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  );
}

function SignOutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}

// v2.19: Pin icon — Bootstrap bi-pin thumbtack. Filled when pinned, outline when not.
function PinIcon({ filled }) {
  if (filled) {
    return (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
        <path d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
      </svg>
    );
  }
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1">
      <path d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
    </svg>
  );
}


/* ─── Utility: sort spaces with pin-to-top logic ─── */

function sortSpaces(spaces) {
  return [...spaces].sort((a, b) => {
    if (a.isPinned && !b.isPinned) return -1;
    if (!a.isPinned && b.isPinned) return 1;
    if (a.isPinned && b.isPinned) {
      return new Date(a.pinnedAt || 0) - new Date(b.pinnedAt || 0);
    }
    return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
  });
}

/* ─── MiniPromptBar: collapsed single-line prompt ─── */

function MiniPromptBar({ prompt, spaceName, onRecord }) {
  const promptText = prompt?.text
    ? prompt.text.replace(/{name}/gi, spaceName || '')
    : 'Record a voice note';

  return (
    <div className={styles.miniPrompt}>
      <p className={styles.miniPromptText}>{promptText}</p>
      <button className={styles.miniPromptBtn} onClick={onRecord}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
          <path d="M19 10v1a7 7 0 0 1-14 0v-1" />
          <line x1="12" y1="18" x2="12" y2="22" />
        </svg>
        Record
      </button>
    </div>
  );
}

/* ═══════════════════════════════════════
   SPACE PAGE COMPONENT
   ═══════════════════════════════════════ */

export default function SpacePage() {
  const { spaceId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { getAccessTokenSilently, logout, user } = useAuth0();
  const appState = useAppContext();

  // v2.29: 2.1c — fail-closed: anything but explicit true renders legacy UI
  const momentsEnabled = appState.flags?.moments_enabled === true;
  // B2a: the Pending Approval tab is a leader-only surface (handleReviewMemory is
  // owner-scoped to the group-space owner). Gate the flag on pilotRole === 'leader'
  // (mirrors the Group Dashboard sidebar gating) so non-leader pilot members never
  // see an empty approval tab. Dark unless the flag is on.
  const groupSpacesEnabled = appState.flags?.group_spaces_enabled === true
    && appState?.pilotRole === 'leader';

  // feed_redesign_v2 (AD 2026-07-27): static header + bordered cards, layered on
  // the moments Hearth feed. The moments dependency is resolved SERVER-SIDE
  // (anamoria-spaces v1.9 emits feed_redesign_v2 = moments && redesign), so the
  // SPA reads the single resolved boolean here. Fail-closed.
  const feedRedesignEnabled = appState.flags?.feed_redesign_v2 === true;
  // W2 member tags — self-tag of own memories, read-only chips on feed cards. Fail-closed.
  const memberTagsEnabled = appState.flags?.member_tags_enabled === true;

  // v2.25: Reactive notification navigation state.
  // Driven by location.state._navKey — each notification click produces a
  // unique key, so this effect fires even on same-route navigation.
  // Replaces the v2.20 one-time const initialTab which only ran on mount.
  const [notificationTab, setNotificationTab] = useState(location.state?.tab || null);
  const [highlightMemoryId, setHighlightMemoryId] = useState(location.state?.memoryId || null);
  // 3.2 (F-D2(a)): a return from MomentDetailPage carries scrollOnly — the
  // feed scrolls to the card without the pulse (pulse = changed content).
  const [highlightMode, setHighlightMode] = useState(
    location.state?.scrollOnly ? 'scroll' : 'pulse'
  );

  // 4.3 (D-4.17): a return from a whole-memory remove carries removedToast —
  // surface the DS-13 confirmation on the feed, then strip it from history so
  // a back-navigation or refresh doesn't replay it.
  const [removedToastVisible, setRemovedToastVisible] = useState(
    location.state?.removedToast === true
  );
  const [groupNoteToastVisible, setGroupNoteToastVisible] = useState(false); // v2.53 (NEW-162)
  useEffect(() => {
    if (location.state?.removedToast) {
      const { removedToast, ...rest } = location.state || {};
      window.history.replaceState({ usr: rest }, '');
    }
  }, []);

  useEffect(() => {
    if (location.state?.tab) {
      setNotificationTab(location.state.tab);
      setHighlightMemoryId(location.state.memoryId || null);
      setHighlightMode('pulse'); // 3.2: notification navigations always pulse
      // Clear consumed state so back-navigation doesn't re-trigger
      const { tab, memoryId, _navKey, scrollOnly, ...rest } = location.state || {};
      window.history.replaceState({ usr: rest }, '');
    }
  }, [location.state?._navKey]);

  const getApi = useCallback(
    () => createApiClient(getAccessTokenSilently),
    [getAccessTokenSilently]
  );

  const { billing } = useBillingStatus(getApi);
  const planLabel = getPlanLabel(billing);

  const currentTier = billing?.tier || 'free';
  const billingEnabled = billing?.billingEnabled !== false;
  const planLink = (() => {
    if (!billingEnabled) return null;
    if (currentTier === 'forever') {
      return { label: 'My Plan →', route: `/settings?from=${spaceId}&section=billing` };
    }
    if (currentTier === 'premium') {
      return { label: 'Change Plan →', route: `/settings/upgrade?from=${spaceId}` };
    }
    return { label: 'Upgrade →', route: `/settings/upgrade?from=${spaceId}` };
  })();

  const [space, setSpace] = useState(null);

  // v2.53 (NEW-162): the leader shares a note with the group. Immediate; the server scopes it to the
  // leader's own group. On success the new note becomes current and the previous one moves to Earlier.
  const handleShareGroupNote = useCallback(async (body) => {
    const api = getApi();
    const res = await api.post('/leader/note', { body });
    const note = res?.note;
    if (!note) throw new Error('NO_NOTE');
    setSpace((prev) => {
      if (!prev) return prev;
      const prevNotes = prev.groupNotes || { current: null, earlier: [] };
      const earlier = prevNotes.current ? [prevNotes.current, ...(prevNotes.earlier || [])].slice(0, 20) : (prevNotes.earlier || []);
      const next = { ...prev, groupNotes: { current: { ...note, authorName: appState?.displayName || null }, earlier } };
      setCache(`space:${spaceId}`, next, SPACE_DETAIL_CACHE_TTL);
      return next;
    });
    setGroupNoteToastVisible(true);
  }, [getApi, spaceId, appState?.displayName]);
  const [prompt, setPrompt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [memoryCount, setMemoryCount] = useState(0);
  const [ownerMemoryCount, setOwnerMemoryCount] = useState(0);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showSoftGate, setShowSoftGate] = useState(false);
  const [softGateResource, setSoftGateResource] = useState('memories');

  // v2.17: Space photo — resolved CloudFront signed URL for header avatar
  const [spacePhotoUrl, setSpacePhotoUrl] = useState(null);

  // v2.17: Sidebar photo URL cache — keyed by spaceId, avoids re-fetching
  const sidebarPhotoCache = useRef({});
  const [sidebarPhotos, setSidebarPhotos] = useState({});

  // v2.26 (account-link F2): "Spaces you contribute to" — lazy-loaded on first
  // sidebar open via GET /me/contributions (owner JWT client). Linked-account
  // contributions only; empty list renders nothing.
  const [linkedContribs, setLinkedContribs] = useState([]);
  const [linkedError, setLinkedError] = useState('');
  const linkedLoadedRef = useRef(false);       // fetch once per mount
  const [unlinkingId, setUnlinkingId] = useState(null);  // spaceId in inline-confirm
  const [unlinkBusyId, setUnlinkBusyId] = useState(null); // spaceId with DELETE in flight

  // v2.18: Collapsible prompt — ref-only, no React state.
  // promptCollapsedRef tracks collapse for the scroll handler.
  // promptSectionRef is the DOM element to toggle data attribute on.
  // No useState for collapse = no re-renders on scroll.
  const promptCollapsedRef = useRef(false);
  const cumulativeUpRef = useRef(0);
  const promptSectionRef = useRef(null);
  const mainRef = useRef(null);
  const heroRef = useRef(null); // v2.42: feed hero collapse-on-scroll
  const stickyAddRef = useRef(null); // v2.43: sticky "Add a memory" — fades into the header when the hero collapses (shares the [data-collapsed] toggle)
  const headerInfoRef = useRef(null); // v2.44: header space-name — fades on narrow screens when collapsed so the sticky Add owns the header center
  const lastScrollY = useRef(0);

  // ─── v2.22: Onboarding tour state ──────────────────────────────
  const [tourActive, setTourActive] = useState(false);
  const [tourPromptVisible, setTourPromptVisible] = useState(false);
  const [tourPromptDismissed, setTourPromptDismissed] = useState(false);

  // T-5 (2026-09-13): persona-aware tour. On the redesigned surface (feed_redesign_v2)
  // the Member/Owner steps are anchored to today's UI (MomentFooter add/invite + feed
  // tabs); copy = Anamoria_AppTour_MemberOwner_Copy_v0.4. The loved-one name is
  // interpolated (falls back to "your loved one"). Legacy (flag-off) steps kept
  // byte-identical (Parallel Change) with the momentsEnabled filter.
  const tourWho = space?.name || 'your loved one';
  const TOUR_STEPS = feedRedesignEnabled
    ? [
      { target: 'space-header',      title: `A space for ${tourWho}`,         content: `This is your private space to keep memories of ${tourWho}, and add to them whenever you're ready.`, position: 'below' },
      { target: 'add-memory',        title: 'Add a memory',                   content: `You can add a memory of ${tourWho} here, in your own voice, in writing, or with a photo or video.`, position: 'above' },
      { target: 'feed-tabs',         title: 'Private, Shared, and Favorites', content: 'Your memories are private. As you add them, you can keep some just for you, share others with the people you invite, and mark the ones you want to find again.', position: 'below' },
      { target: 'invite-btn',        title: 'Invite someone',                 content: `When you're ready, you can invite someone you trust to add their own memories of ${tourWho}. They only see what you choose to share.`, position: 'above' },
      { target: 'notification-bell', title: 'When someone adds a memory',     content: `You'll hear from us here when someone you invited adds a memory, or if there's something you need to know.`, position: 'below' },
      { target: 'settings-gear',     title: 'Settings and privacy',           content: 'You can set a PIN to keep this space private on your device, and manage your account here. Take your time.', position: 'below' },
      { target: 'sidebar-toggle',    title: 'Your spaces',                    content: `If you're holding more than one space, you can move between them here, and find your account and help whenever you need.`, position: 'right' },
    ]
    : [
      { target: 'space-header',      title: 'Your memory space',   content: 'This is your personal, private space to capture and preserve memories of your loved one.', position: 'below' },
      { target: 'prompt-area',       title: 'Daily prompts',       content: 'Each day you\'ll see a new prompt to inspire a memory. Just tap to start recording.', position: 'below' },
      { target: 'record-btn',        title: 'Record a voice note', content: 'Tap here to record a voice memory anytime.', position: 'above' },
      { target: 'write-btn',         title: 'Write a memory',      content: 'Tap here if you prefer to write.', position: 'above' },
      { target: 'photo-btn',         title: 'Add photos',          content: 'Add photos anytime.', position: 'above' },
      { target: 'video-btn',         title: 'Record a video',      content: 'Record or add videos.', position: 'above' },
      { target: 'notification-bell', title: 'Notifications',       content: 'You\'ll see notifications here when someone you invited contributes a memory, or if there are app notifications.', position: 'below' },
      { target: 'sidebar-toggle',    title: 'Your spaces & more',  content: 'Click here to access your spaces, view your plan and more.', position: 'right' },
      { target: 'settings-gear',     title: 'Stay secure',         content: 'Navigate to settings easily and set a pin to lock the app after inactivity.', position: 'below' },
    ].filter(step => !(momentsEnabled &&
      ['record-btn', 'write-btn', 'photo-btn', 'video-btn', 'settings-gear'].includes(step.target)));

  // v2.22: Check location.state.startTour (from Settings → "Start tour")
  // v2.25: Clear only startTour from state (was clearing all state with
  // empty object, which nuked tab/memoryId from notification navigation).
  useEffect(() => {
    if (location.state?.startTour) {
      setTourActive(true);
      const { startTour, ...rest } = location.state || {};
      window.history.replaceState({ usr: rest }, '');
    }
  }, [location.state]);

  // v2.22: Show tour prompt for non-onboarded users after space loads
  useEffect(() => {
    if (!loading && space && appState && !appState.onboardingComplete && !tourPromptDismissed && !tourActive) {
      setTourPromptVisible(true);
    }
  }, [loading, space, appState, tourPromptDismissed, tourActive]);

  // v2.22: Tour handlers
  function handleTourStart() {
    setTourPromptVisible(false);
    setTourActive(true);
  }

  function handleTourComplete() {
    // v2.28: The tour's last step PATCHes /pilot/onboarding (onboarding_complete=true).
    // Sync appState so the gate above closes for this session and the prompt stops
    // re-firing on every feed remount (previously only a hard refresh cleared it).
    if (appState?.updateOnboarding) appState.updateOnboarding({ onboardingComplete: true });
    setTourActive(false);
  }

  function handleTourSkip() {
    setTourActive(false);
  }

  function handleTourPromptDismiss(result) {
    // v2.28: If the dismiss (POST /pilot/onboarding/dismiss) flipped the flag
    // (3rd dismissal, BP-7 fatigue), sync it so the prompt does not return.
    if (result?.onboardingComplete && appState?.updateOnboarding) {
      appState.updateOnboarding({ onboardingComplete: true });
    }
    setTourPromptVisible(false);
    setTourPromptDismissed(true);
  }

  // v2.23: Dismiss tour when app is backgrounded (prevents tour overlay
  // rendering on top of PIN lock screen when device times out).
  useEffect(() => {
    if (!tourActive) return;

    function handleVisibilityChange() {
      if (document.hidden) {
        setTourActive(false);
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [tourActive]);

  /* ─── Load space + prompt + owner memory count ─── */

  useEffect(() => {
    async function load() {
      const cachedSpace = getCached(`space:${spaceId}`);
      const cachedPrompt = getCached(`prompt:${spaceId}`);

      if (cachedSpace.hit && cachedPrompt.hit) {
        setSpace(cachedSpace.value);
        setPrompt(cachedPrompt.value);
        try {
          const api = getApi();
          const countData = await api.get(`/spaces/${spaceId}/memories/count`).catch(() => ({ count: 0 }));
          setOwnerMemoryCount(countData?.count ?? 0);
        } catch { /* count is non-critical */ }
        setLoading(false);
        return;
      }

      setLoading(true);
      setError('');
      try {
        const api = getApi();
        const [spaceData, promptData, countData] = await Promise.all([
          api.get(`/spaces/${spaceId}`),
          api.get(`/spaces/${spaceId}/prompt`).catch(() => null),
          api.get(`/spaces/${spaceId}/memories/count`).catch(() => ({ count: 0 })),
        ]);
        setCache(`space:${spaceId}`, spaceData, SPACE_DETAIL_CACHE_TTL);
        setCache(`prompt:${spaceId}`, promptData, PROMPT_CACHE_TTL);

        setSpace(spaceData);
        setPrompt(promptData);
        setOwnerMemoryCount(countData?.count ?? 0);
      } catch (err) {
        console.error('SpacePage load error:', err);
        setError('Could not load this space.');
      } finally {
        setLoading(false);
      }
    }
    load();
    // v2.18: Reset collapse state on space change
    promptCollapsedRef.current = false;
    cumulativeUpRef.current = 0;
    lastScrollY.current = 0;
    if (promptSectionRef.current) {
      promptSectionRef.current.removeAttribute('data-collapsed');
    }
    if (heroRef.current) {
      heroRef.current.removeAttribute('data-collapsed');
    }
    if (stickyAddRef.current) {
      stickyAddRef.current.removeAttribute('data-collapsed');
    }
    if (headerInfoRef.current) {
      headerInfoRef.current.removeAttribute('data-collapsed');
    }
  }, [spaceId, getApi]);

  /* ─── v2.17: Resolve space photo S3 key to CloudFront signed URL ─── */
  /* v2.17.1: Removed encodeURIComponent — {key+} accepts raw slashes */

  useEffect(() => {
    if (!space?.photoUrl) {
      setSpacePhotoUrl(null);
      return;
    }
    let cancelled = false;
    async function resolve() {
      try {
        const api = getApi();
        const data = await api.get(`/media/playback/${space.photoUrl}`);
        if (!cancelled && data?.playbackUrl) {
          setSpacePhotoUrl(data.playbackUrl);
        }
      } catch (err) {
        console.error('Failed to resolve space photo:', err);
        if (!cancelled) setSpacePhotoUrl(null);
      }
    }
    resolve();
    return () => { cancelled = true; };
  }, [space?.photoUrl, getApi]);

  /* ─── v2.17: Resolve sidebar space photos ─── */
  /* v2.17.1: Removed encodeURIComponent — {key+} accepts raw slashes */

  useEffect(() => {
    if (!sidebarOpen || !appState?.spaces) return;
    let cancelled = false;

    async function resolvePhotos() {
      const spacesWithPhotos = appState.spaces.filter(
        (s) => s.photoUrl && !sidebarPhotoCache.current[s.id]
      );
      if (spacesWithPhotos.length === 0) return;

      const api = getApi();
      const results = {};

      await Promise.all(
        spacesWithPhotos.map(async (s) => {
          try {
            const data = await api.get(`/media/playback/${s.photoUrl}`);
            if (data?.playbackUrl) {
              results[s.id] = data.playbackUrl;
              sidebarPhotoCache.current[s.id] = data.playbackUrl;
            }
          } catch {
            // Photo resolution failure is non-critical — fall back to initial
          }
        })
      );

      if (!cancelled && Object.keys(results).length > 0) {
        setSidebarPhotos((prev) => ({ ...prev, ...results }));
      }
    }
    resolvePhotos();
    return () => { cancelled = true; };
  }, [sidebarOpen, appState?.spaces, getApi]);

  /* ─── v2.26 (account-link F2): lazy-load "Spaces you contribute to" ───
     Fetches GET /me/contributions on the FIRST sidebar open only (linkedLoadedRef
     guard), via the owner JWT client. Not part of bootstrap — same lazy pattern
     as sidebar photos above, so the initial app load is unchanged. */
  useEffect(() => {
    if (!sidebarOpen || linkedLoadedRef.current) return;
    linkedLoadedRef.current = true;

    let cancelled = false;
    async function loadLinked() {
      setLinkedError('');
      try {
        const api = getApi();
        const data = await api.get('/me/contributions');
        if (!cancelled) setLinkedContribs(data.contributions || []);
      } catch (err) {
        if (!cancelled) {
          // Non-critical: the rest of the sidebar still works. Allow a retry
          // on next open by clearing the once-guard.
          linkedLoadedRef.current = false;
          setLinkedError('Could not load your contributions.');
        }
      }
    }
    loadLinked();
    return () => { cancelled = true; };
  }, [sidebarOpen, getApi]);

  /* ─── v2.18: Scroll direction tracking for collapsible prompt ─── */
  /* The prompt section is OUTSIDE the scroll container (.main), so
     changing its height does not affect main.scrollTop — no oscillation.
     Uses a ref + data attribute toggle instead of React state to avoid
     re-renders on every scroll event. Dependency is [loading] so the
     listener attaches once mainRef.current exists after initial render. */

  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;

    function handleScroll() {
      const currentY = el.scrollTop;
      const delta = currentY - lastScrollY.current;

      if (delta > 0) {
        // Scrolling down — reset cumulative up counter
        cumulativeUpRef.current = 0;

        // v2.45: only collapse when the feed stays comfortably scrollable AFTER the
        // hero (a flex sibling above flex:1 .main) collapses to height 0 and frees its
        // height into .main. On a short feed, collapsing flips .main scrollable<->not,
        // the browser clamps scrollTop, and collapse<->expand oscillates (the flashing
        // seen with ~5 memories). Short feeds simply stay expanded.
        // v2.49 (B4): flag-on hero scrolls away inside .main -- no hero collapse. Once scrolled,
        // fade in the sticky Add (and fade the header name on narrow). Legacy prompt (flag-off)
        // keeps its guarded collapse to avoid short-feed oscillation.
        const remaining = el.scrollHeight - el.clientHeight;
        if (currentY > 50 && !promptCollapsedRef.current && (feedRedesignEnabled || remaining > 160)) {
          promptCollapsedRef.current = true;
          if (!feedRedesignEnabled && promptSectionRef.current) {
            promptSectionRef.current.setAttribute('data-collapsed', '');
          }
          if (stickyAddRef.current) {
            stickyAddRef.current.setAttribute('data-collapsed', '');
          }
          if (headerInfoRef.current) {
            headerInfoRef.current.setAttribute('data-collapsed', '');
          }
        }
      } else if (delta < 0 && promptCollapsedRef.current) {
        // Scrolling up — accumulate distance
        cumulativeUpRef.current += Math.abs(delta);

        if (cumulativeUpRef.current > 50 || currentY < 10) {
          promptCollapsedRef.current = false;
          cumulativeUpRef.current = 0;
          if (promptSectionRef.current) {
            promptSectionRef.current.removeAttribute('data-collapsed');
          }
          if (heroRef.current) {
            heroRef.current.removeAttribute('data-collapsed');
          }
          if (stickyAddRef.current) {
            stickyAddRef.current.removeAttribute('data-collapsed');
          }
          if (headerInfoRef.current) {
            headerInfoRef.current.removeAttribute('data-collapsed');
          }
        }
      }

      if (delta > 0) cumulativeUpRef.current = 0;
      lastScrollY.current = currentY;
    }

    // v2.45: rAF-throttle so bursts of scroll events coalesce into one layout
    // read/write per frame (the trace showed heavy paint/commit churn).
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { handleScroll(); ticking = false; });
    }
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [loading, feedRedesignEnabled]);

  /* ─── Load spaces list for sidebar (A-4: fallback only) ─── */

  const loadSpaces = useCallback(async () => {
    if ((appState?.spaces?.length || 0) > 0) return;
    try {
      const api = getApi();
      const data = await api.get('/spaces');
      const fetched = data.spaces || [];
      if (appState?.updateSpaces) appState.updateSpaces(fetched);
    } catch (err) {
      console.error('Spaces list fallback error:', err);
    }
  }, [getApi, appState]);

  const openSidebar = useCallback(() => {
    setSidebarOpen(true);
    loadSpaces();
  }, [loadSpaces]);

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false);
    setShowUserMenu(false);
  }, []);

  const switchSpace = useCallback((id) => {
    closeSidebar();
    navigate(`/spaces/${id}`);
  }, [navigate, closeSidebar]);

  /* ─── v2.26 (account-link F2): navigate into a linked space (F1 route) ─── */
  const openLinkedSpace = useCallback((spaceId) => {
    closeSidebar();
    navigate(`/contributing/${spaceId}/memories`);
  }, [navigate, closeSidebar]);

  /* ─── v2.26: unlink a contribution (inline confirm) ───
     Clears the account link only (DELETE /me/contributions/:spaceId/link).
     Does NOT delete contributions or change contributor status. On success the
     row is removed from the local list. */
  const handleUnlink = useCallback(async (spaceId) => {
    if (unlinkBusyId) return;
    setUnlinkBusyId(spaceId);
    try {
      const api = getApi();
      await api.delete(`/me/contributions/${spaceId}/link`);
      setLinkedContribs((prev) => prev.filter((c) => c.spaceId !== spaceId));
      setUnlinkingId(null);
    } catch (err) {
      setLinkedError('Could not unlink. Please try again.');
    } finally {
      setUnlinkBusyId(null);
    }
  }, [getApi, unlinkBusyId]);

  /* ─── v2.17: Pin/unpin space (optimistic update) ─── */

  const handleTogglePin = useCallback(async (e, targetSpace) => {
    e.stopPropagation();
    const newPinned = !targetSpace.isPinned;

    if (appState?.updateSpaces && appState?.spaces) {
      const updated = appState.spaces.map((s) =>
        s.id === targetSpace.id
          ? { ...s, isPinned: newPinned, pinnedAt: newPinned ? new Date().toISOString() : null }
          : s
      );
      appState.updateSpaces(sortSpaces(updated));
    }

    try {
      const api = getApi();
      await api.patch(`/spaces/${targetSpace.id}`, { isPinned: newPinned });
    } catch (err) {
      console.error('Pin toggle failed:', err);
      try {
        const api = getApi();
        const data = await api.get('/spaces');
        if (appState?.updateSpaces) appState.updateSpaces(data.spaces || []);
      } catch { /* revert best-effort */ }
    }
  }, [appState, getApi]);

  function handleRecord() {
    if (billing?.tier === 'free' && billing?.limits?.memoriesPerSpace) {
      if (ownerMemoryCount >= billing.limits.memoriesPerSpace) {
        setSoftGateResource('memories');
        setShowSoftGate(true);
        return;
      }
    }
    navigate(`/spaces/${spaceId}/record`, {
      state: { promptId: prompt?.promptId || null },
    });
  }

  const handleSkipPrompt = useCallback(async () => {
    try {
      const api = getApi();
      const nextPrompt = await api.post(`/spaces/${spaceId}/prompt/advance`);
      if (nextPrompt) {
        setPrompt(nextPrompt);
        setCache(`prompt:${spaceId}`, nextPrompt, PROMPT_CACHE_TTL);
      }
    } catch (err) {
      console.error('Skip prompt error:', err);
    }
  }, [getApi, spaceId]);

  function handleCreateSpace() {
    if (billing?.tier === 'free' && billing?.limits?.spaces) {
      if ((appState?.spaces?.length || 0) >= billing.limits.spaces) {
        setSoftGateResource('spaces');
        setShowSoftGate(true);
        return;
      }
    }
    setShowCreateModal(true);
  }

  const handleMemoryCount = useCallback((count) => {
    setMemoryCount(count);
  }, []);

  if (error) {
    return (
      <div className="app-error">
        <h2>Something went wrong</h2>
        <p>{error}</p>
        <button className="app-error-btn" onClick={() => window.location.reload()}>
          Retry
        </button>
      </div>
    );
  }

  if (loading || !space) {
    return null;
  }

  const isShared = space.privacyMode === 'shared';
  const initial = (space.name || '?').charAt(0).toUpperCase();

  const sortedSpaces = sortSpaces(appState?.spaces || []);
  const pinnedSpaces = sortedSpaces.filter((s) => s.isPinned);
  const unpinnedSpaces = sortedSpaces.filter((s) => !s.isPinned);

  return (
    <div className={`${styles.page}${momentsEnabled ? ` ${styles.pageV}` : ''}${feedRedesignEnabled ? ` ${styles.pageV2}` : ''}`}>

      {/* 4.3 (D-4.17): after-remove confirmation; one-tap undo = fast-follow. */}
      <Toast
        message="Memory removed. You can bring it back in Recently Deleted."
        visible={removedToastVisible}
        durationMs={5000}
        onDismiss={() => setRemovedToastVisible(false)}
      />
      {/* v2.53 (NEW-162): after the leader shares a note. */}
      <Toast
        message="Shared with the group."
        visible={groupNoteToastVisible}
        durationMs={3500}
        onDismiss={() => setGroupNoteToastVisible(false)}
      />

      {/* ═══════════════════════════════════════
          HEADER BAR
          ═══════════════════════════════════════ */}
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <button
            className={styles.headerBtn}
            onClick={openSidebar}
            aria-label="Open space menu"
            data-tour="sidebar-toggle"
          >
            <HamburgerIcon />
          </button>

          <div className={styles.headerAvatar}>
            {spacePhotoUrl ? (
              <img src={spacePhotoUrl} alt="" className={styles.avatarImg} />
            ) : (
              <span className={styles.avatarInitial}>{initial}</span>
            )}
          </div>

          <div className={styles.headerInfo} data-tour="space-header" ref={headerInfoRef}>
            <h1 className={styles.headerName}>{space.name}</h1>
            <p className={styles.headerSub}>
              {space.isGroupSpace === true ? (
                <>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="8" r="3" />
                    <path d="M3 20a6 6 0 0 1 12 0" />
                    <path d="M16 6a3 3 0 0 1 0 6" />
                    <path d="M18 20a6 6 0 0 0-3-5.2" />
                  </svg>
                  {' '}Group space
                </>
              ) : isShared ? (
                <>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                  </svg>
                  {' '}Shared
                </>
              ) : (
                <>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                  </svg>
                  {' '}Private
                </>
              )}
              {' · '}{memoryCount} {memoryCount === 1 ? 'memory' : 'memories'}
            </p>
          </div>
        </div>

        {/* v2.20→v2.21: Header right — + button, notification bell, settings gear */}
        <div className={styles.headerRight}>
          {/* v2.52: leader-only Group Dashboard entry (surfaces the sidebar link). */}
          {space.isGroupSpace === true && appState?.pilotRole === 'leader' && (
            <button
              className={styles.headerDashBtn}
              onClick={() => navigate('/leader')}
              aria-label="Group Dashboard"
              title="Group Dashboard"
            >
              <DashboardIcon />
              <span className={styles.headerDashLabel}>Group Dashboard</span>
            </button>
          )}
          <button
            className={styles.headerBtn}
            onClick={handleCreateSpace}
            aria-label="Create new space"
          >
            <PlusIcon />
          </button>
          <span data-tour="notification-bell">
            <NotificationBell getApi={getApi} />
          </span>
          {/* v2.29: 2.1c — gear omitted when the footer is the sole Settings entry (D8) */}
          {!momentsEnabled && (
            <button
              className={styles.headerBtn}
              onClick={() => navigate(`/settings?from=${spaceId}`, { state: { backgroundLocation: location } })}
              aria-label="Settings"
              data-tour="settings-gear"
            >
              <SettingsIcon size={20} />
            </button>
          )}
        </div>
      </header>

      {/* ═══════════════════════════════════════
          HEADER / PROMPT SECTION (outside scroll container)
          feed_redesign_v2 (flag): a static "A space for {name}" header replaces
          the prompt. Flag off ⇒ the legacy prompt section below, byte-identical.
          v2.18: Sits between header and main in the flex column.
          Collapse/expand changes this element's height without
          affecting main.scrollTop — eliminates oscillation.
          Both full prompt and mini bar rendered; CSS toggles visibility
          via data-collapsed attribute. No React state on scroll.
          ═══════════════════════════════════════ */}
      {/* v2.49 (B4): flag-on hero now lives INSIDE <main> so it scrolls away smoothly (below).
          Flag-off legacy prompt still renders here, outside the scroll container. */}
      {!feedRedesignEnabled && (
      <div className={styles.promptSection} ref={promptSectionRef}>
        {/* Full prompt — hidden when collapsed */}
        <div className={styles.promptFull}>
          <div className={styles.promptArea} data-tour="prompt-area">
            {prompt ? (
              <PromptCard
                prompt={prompt}
                spaceName={space.name}
                onRecord={handleRecord}
                onSkip={handleSkipPrompt}
              />
            ) : (
              <div className={styles.noPromptCta}>
                <button className={styles.recordBtn} onClick={handleRecord}>
                  <span className={styles.recordBtnIcon}>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" strokeLinecap="round" strokeLinejoin="round">
                      <path className={styles.recordBtnFill} d="M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
                      <path d="M18 10.5v.5a6 6 0 0 1-12 0v-.5" strokeWidth="1.5" stroke="white" />
                      <path d="M12 17v4" strokeWidth="1.5" stroke="white" />
                    </svg>
                  </span>
                  Record a voice note
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Mini prompt bar — shown when collapsed */}
        <div className={styles.promptMini}>
          <MiniPromptBar
            prompt={prompt}
            spaceName={space.name}
            onRecord={handleRecord}
          />
        </div>
      </div>
      )}

      {/* ═══════════════════════════════════════
          MAIN CONTENT (scroll container)
          v2.18: Only contains MemoryFeed (tabs + masonry).
          Prompt is above, outside this scroll container.
          ═══════════════════════════════════════ */}
      {feedRedesignEnabled && (
        <button
          className={styles.feedStickyAdd}
          ref={stickyAddRef}
          onClick={() => navigate(`/spaces/${spaceId}/add`)}
          aria-label="Add a memory"
        >
          <span aria-hidden="true">＋</span> Add a memory
        </button>
      )}
      <main className={styles.main} ref={mainRef}>
        {/* v2.49 (B4): hero inside the scroll container — scrolls away naturally (native, smooth);
            the sticky tabs (MemoryFeed .tabs, position:sticky top:0) pin as it leaves. */}
        {feedRedesignEnabled && (
          <div className={styles.feedHeaderV2}>
          <div className={styles.heroInner}>
            <p className={styles.feedHeaderLabel}>Memories</p>
            <h2 className={styles.feedHeaderTitle}>A space for {space.name}.</h2>
            <p className={styles.feedHeaderSub}>
              {space.isGroupSpace === true
                ? 'Somewhere to remember and keep our loved ones close'
                : 'Somewhere to remember and keep them close'}
            </p>
            <button
              className={styles.feedHeaderAddBtn}
              onClick={() => navigate(`/spaces/${spaceId}/add`)}
            >
              Add a memory
            </button>
          </div>
          </div>
        )}
        {/* v2.22: Tour prompt — shown for non-onboarded users */}
        <TourPrompt
          visible={tourPromptVisible}
          onStart={handleTourStart}
          onDismiss={handleTourPromptDismiss}
          getApi={getApi}
        />
        {/* Memory feed — full width masonry */}
        <MemoryFeed
          spaceId={spaceId}
          getApi={getApi}
          onMemoryCount={handleMemoryCount}
          voiceCardTheme={space?.voiceCardTheme || 'warm'}
          initialTab={notificationTab || (space?.isGroupSpace === true ? 'shared' : undefined)}
          highlightMemoryId={highlightMemoryId}
          highlightMode={highlightMode}
          momentsEnabled={momentsEnabled}
          feedRedesignEnabled={feedRedesignEnabled}
          memberTagsEnabled={memberTagsEnabled}
          groupSpacesEnabled={groupSpacesEnabled}
          spaceIsGroup={space?.isGroupSpace === true}
          topSlot={space?.isGroupSpace === true && appState.flags?.group_spaces_enabled === true ? (
            /* v2.53 (NEW-162): the leader's note, under the tabs and first in the feed (mockup v0.9, placement C). */
            <GroupNoteBanner
              groupNotes={space.groupNotes}
              leaderName={appState?.displayName}
              canShare={appState?.pilotRole === 'leader'}
              onShare={handleShareGroupNote}
            />
          ) : null}
          pendingReviewCount={space?.pendingReviewCount ?? 0}
          spaceName={space?.name}
          groupNotes={space?.groupNotes}   /* v2.54 (NEW-163): response-card pill */
          leaderName={appState?.displayName}
        />
      </main>

      {/* v2.29: 2.1c — flag-gated footer swap (D8); fail-closed to legacy BottomNav */}
      {momentsEnabled
        ? <MomentFooter spaceId={spaceId} redesign={feedRedesignEnabled} />
        : <BottomNav spaceId={spaceId} activeTab="record" />}

      {/* ═══════════════════════════════════════
          SIDEBAR DRAWER
          ═══════════════════════════════════════ */}
      {sidebarOpen && (
        <>
          <div className={styles.sidebarBackdrop} onClick={closeSidebar} />
          <aside className={styles.sidebar}>
            <div className={styles.sidebarHeader}>
              <h2 className={styles.sidebarTitle}>Your Memory Spaces</h2>
              <button
                className={styles.sidebarClose}
                onClick={closeSidebar}
                aria-label="Close menu"
              >
                <CloseIcon />
              </button>
            </div>

            {appState?.pilotRole === 'leader' && (
              <div className={styles.sidebarLeaderHome}>
                <button
                  type="button"
                  className={styles.sidebarSpace}
                  onClick={() => { closeSidebar(); navigate('/leader'); }}
                >
                  <span className={styles.sidebarAvatar}><DashboardIcon /></span>
                  <span className={styles.sidebarSpaceName}>Leader home</span>
                </button>
              </div>
            )}

            <div className={styles.sidebarSection}>
              <p className={styles.sidebarSectionTitle}>SWITCH SPACE</p>

              {/* Pinned spaces */}
              {pinnedSpaces.length > 0 && (
                <>
                  {pinnedSpaces.map((s) => {
                    const sInitial = (s.name || '?').charAt(0).toUpperCase();
                    const isActive = s.id === spaceId;
                    const photoSrc = sidebarPhotos[s.id] || sidebarPhotoCache.current[s.id] || null;
                    return (
                      <button
                        key={s.id}
                        className={`${styles.sidebarSpace} ${isActive ? styles.sidebarSpaceActive : ''}`}
                        onClick={() => switchSpace(s.id)}
                      >
                        <span className={`${styles.sidebarAvatar} ${isActive ? styles.sidebarAvatarActive : ''}`}>
                          {photoSrc ? (
                            <img src={photoSrc} alt="" className={styles.sidebarAvatarImg} />
                          ) : (
                            sInitial
                          )}
                        </span>
                        <span className={styles.sidebarSpaceName}>{s.name}</span>
                        <span
                          className={`${styles.pinBtn} ${styles.pinBtnPinned}`}
                          onClick={(e) => handleTogglePin(e, s)}
                          title="Unpin space"
                          role="button"
                          tabIndex={0}
                        >
                          <PinIcon filled />
                        </span>
                      </button>
                    );
                  })}
                  {unpinnedSpaces.length > 0 && (
                    <div className={styles.pinDivider} />
                  )}
                </>
              )}

              {/* Un-pinned spaces */}
              {unpinnedSpaces.map((s) => {
                const sInitial = (s.name || '?').charAt(0).toUpperCase();
                const isActive = s.id === spaceId;
                const photoSrc = sidebarPhotos[s.id] || sidebarPhotoCache.current[s.id] || null;
                return (
                  <button
                    key={s.id}
                    className={`${styles.sidebarSpace} ${isActive ? styles.sidebarSpaceActive : ''}`}
                    onClick={() => switchSpace(s.id)}
                  >
                    <span className={`${styles.sidebarAvatar} ${isActive ? styles.sidebarAvatarActive : ''}`}>
                      {photoSrc ? (
                        <img src={photoSrc} alt="" className={styles.sidebarAvatarImg} />
                      ) : (
                        sInitial
                      )}
                    </span>
                    <span className={styles.sidebarSpaceName}>{s.name}</span>
                    {s.privacyMode === 'private' && (
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#737373" strokeWidth="1.5" strokeLinecap="round" style={{ marginLeft: 'auto', opacity: 0.5, flexShrink: 0 }}>
                        <rect x="5" y="11" width="14" height="10" rx="2" />
                        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                      </svg>
                    )}
                    <span
                      className={styles.pinBtn}
                      onClick={(e) => handleTogglePin(e, s)}
                      title="Pin to top"
                      role="button"
                      tabIndex={0}
                    >
                      <PinIcon filled={false} />
                    </span>
                  </button>
                );
              })}
            </div>

            {/* ── v2.26 (account-link F2): Spaces you contribute to ──
                Only renders once there's a result or a genuine error — NOT
                during the load — so the header never flashes-then-vanishes for
                users with no linked spaces (the common case). */}
            {(linkedError || linkedContribs.length > 0) && (
              <div className={styles.sidebarSection}>
                <p className={styles.sidebarSectionTitle}>SPACES YOU CONTRIBUTE TO</p>

                {linkedError && (
                  <p className={styles.sidebarLinkedHint}>{linkedError}</p>
                )}

                {linkedContribs.map((c) => {
                  const cInitial = (c.spaceName || '?').charAt(0).toUpperCase();
                  const confirming = unlinkingId === c.spaceId;
                  const busy = unlinkBusyId === c.spaceId;
                  return (
                    <div key={c.spaceId} className={styles.sidebarLinkedRow}>
                      <button
                        type="button"
                        className={styles.sidebarSpace}
                        onClick={() => openLinkedSpace(c.spaceId)}
                      >
                        <span className={styles.sidebarAvatar}>{cInitial}</span>
                        <span className={styles.sidebarSpaceName}>{c.spaceName}</span>
                      </button>

                      {confirming ? (
                        <span className={styles.sidebarUnlinkConfirm}>
                          <button
                            type="button"
                            className={styles.sidebarUnlinkYes}
                            onClick={() => handleUnlink(c.spaceId)}
                            disabled={busy}
                          >
                            {busy ? 'Unlinking…' : 'Unlink'}
                          </button>
                          <button
                            type="button"
                            className={styles.sidebarUnlinkCancel}
                            onClick={() => setUnlinkingId(null)}
                            disabled={busy}
                          >
                            Cancel
                          </button>
                        </span>
                      ) : (
                        <button
                          type="button"
                          className={styles.sidebarUnlinkBtn}
                          onClick={() => setUnlinkingId(c.spaceId)}
                          title="Unlink this space from your account"
                          aria-label={`Unlink ${c.spaceName} from your account`}
                        >
                          Unlink
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {user && (
              <div className={styles.sidebarUserWrapper}>

                {showUserMenu && (
                  <div className={styles.userMenu}>
                    {billingEnabled && (
                    <div className={styles.userMenuPlan}>
                      <span className={styles.userMenuPlanBadge}>{planLabel}</span>
                      <button
                        className={styles.userMenuUpgradeLink}
                        onClick={() => {
                          closeSidebar();
                          navigate(planLink.route);
                        }}
                      >
                        {planLink.label}
                      </button>
                    </div>
                    )}

                    <div className={styles.userMenuDivider} />

                    <button
                      className={styles.userMenuItem}
                      onClick={() => {
                        closeSidebar();
                        navigate(`/settings?from=${spaceId}`, { state: { backgroundLocation: location } });
                      }}
                    >
                      <SettingsIcon />
                      Settings
                    </button>

                    <button
                      className={`${styles.userMenuItem} ${styles.userMenuItemSignOut}`}
                      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                    >
                      <SignOutIcon />
                      Sign out
                    </button>
                  </div>
                )}

                <button
                  className={`${styles.sidebarUser} ${showUserMenu ? styles.sidebarUserOpen : ''}`}
                  onClick={() => setShowUserMenu((v) => !v)}
                  aria-expanded={showUserMenu}
                  aria-label="Profile and settings"
                >
                  <div className={styles.sidebarUserAvatar}>
                    {(appState?.displayName || user.name || user.email || '?').charAt(0).toUpperCase()}
                  </div>
                  <div className={styles.sidebarUserInfo}>
                    <span className={styles.sidebarUserName}>{appState?.displayName || user.name || 'User'}</span>
                    <span className={styles.sidebarUserEmail}>{planLabel}</span>
                  </div>
                  <span className={`${styles.sidebarUserChevron} ${showUserMenu ? styles.sidebarUserChevronUp : ''}`}>
                    <ChevronUpIcon />
                  </span>
                </button>

              </div>
            )}
          </aside>
        </>
      )}


      {showCreateModal && (
        <CreateSpaceModal
          getApi={getApi}
          onClose={() => setShowCreateModal(false)}
        />
      )}

      {showSoftGate && (
        <SoftGateModal
          isOpen={showSoftGate}
          onClose={() => setShowSoftGate(false)}
          resource={softGateResource}
          billing={billing}
          spaceId={spaceId}
        />
      )}

      {/* v2.22: Onboarding tour overlay — renders above all content when active */}
      {tourActive && (
        <OnboardingTour
          steps={TOUR_STEPS}
          onComplete={handleTourComplete}
          onSkip={handleTourSkip}
          getApi={getApi}
        />
      )}

    </div>
  );
}
